/**
 * 注册题型组件
 */
import AnswerQuestion from './AnswerQuestion'
import Completion from './Completion'
import Comprehensive from './Comprehensive'
import Judge from './Judge'
import MultipleChoice from './MultipleChoice'
import NoType from './NoType'
import SingleChoice from './SingleChoice'

export default {
  0: NoType,
  1: SingleChoice,
  2: MultipleChoice,
  3: Completion,
  4: Judge,
  5: AnswerQuestion,
  6: Comprehensive,
}
